import { render, staticRenderFns } from "./SectionSubheading.vue?vue&type=template&id=3f2958e6&scoped=true&lang=html&"
import script from "./SectionSubheading.vue?vue&type=script&lang=js&"
export * from "./SectionSubheading.vue?vue&type=script&lang=js&"
import style0 from "./SectionSubheading.vue?vue&type=style&index=0&id=3f2958e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2958e6",
  null
  
)

export default component.exports